import ActionsForm from '@/shared/mixins/actionsForm'
import GroupDetail from '../TemplateDetail/GroupDetail/GroupDetail.vue'
import qmaTemplate from '@/shared/http/repositories/business/qmaTemplate'
import { toast, loading } from '@/shared/utils/UIHelper'
import ImageNotFound from '../../../../../../../../../static/img/qma/semDados.svg'

export default {
  name: 'templateDetail',
  props: ['templateid'],
  components: {GroupDetail},
  mixins: [ActionsForm],
  data () {
    return {
      notFound: ImageNotFound,
      dadosGrupo: []
    }
  },
  watch: {
  },
  mounted () {
    this.onLoad()
  },
  methods: {
    onLoad () {
      qmaTemplate.GetAvaliacaoMetadadoTemplate(this.templateid)
        .then((Response) => {
          loading.pop()
          if (Response.data.length > 0) {
            this.dadosGrupo = Response.data
          } else {
          }
        })
        .catch((Error) => {
          loading.pop()
          toast.error('Dados não encontrados')
        })
    },
    popUpExcluirTemplate () {
      this.$refs.grupoDetalhesTemplate.popUpExcluirEquipamento()
    },
    abrirPopUpAddEtapa () {
      this.$refs.grupoDetalhesTemplate.abrirModalAddEtapa()
    },
    zeraSubGrupo () {
      this.$refs.grupoDetalhesTemplate.voltarParaGrupos()
    },
    voltaParaGrupo (value) {
      this.$emit('voltaGrupo', value)
    },
    addNovaEtapa (value) {
      this.$emit('addNovaEtapaTemplate', value)
    },
    editarEtapa (value) {
      this.$emit('editarEtapa', value)
    },
    editaSubEtapa (value) {
      this.$emit('editaSubEtapa', value)
    },
    addNovaSubEtapa (value) {
      this.$emit('addNovaSubEtapaTemplateObjEtapaNova', value)
    },
    novaEtapaTemplatePergunta (value) {
      this.$emit('novaEtapaTemplatePergunta', value)
    },
    addNovaSubEtapaObjSemNovaEtapa (value) {
      this.$emit('addNovaSubEtapaObjSemNovaEtapaTemplate', value)
    },
    addNovaPerguntaParaSubEtapa (value) {
      this.$emit('addNovaPerguntaParaSubEtapaTemplate', value)
    },
    addNovaPerguntaEtapaSubCriada (value) {
      this.$emit('addNovaPerguntaEtapaSubCriadaTemplate', value)
    },
    ExcluirPerguntaTemplateDetalheCriado (value) {
      this.$emit('ExcluirPerguntaTemplateDetalheCriado', value)
    },
    ExcluirPerguntaTemplateDetalheSubEtapa (value) {
      this.$emit('ExcluirPerguntaTemplateDetalheSubEtapa', value)
    },
    ExcluirPerguntaTemplateDetalheEtapa (value) {
      this.$emit('ExcluirPerguntaTemplateDetalheEtapa', value)
    },
    removerSubEtapaEtapaCriada (value) {
      this.$emit('removerSubEtapaEtapaTemplateCriada', value)
    },
    removerSubEtapaAgEnvioEtapa (value) {
      this.$emit('removerSubEtapaTemplateAgEnvioEtapa', value)
    },
    ExcluirPerguntaTemplate (value) {
      this.$emit('ExcluirPerguntaTemplate', value)
    },
    RemoverEdicaoExcluirPerguntaTemplate (value) {
      this.$emit('RemoverEdicaoExcluirPerguntaTemplate', value)
    },
    ExcluirSubEtapasEtapasTemplateDetalhe (value) {
      this.$emit('ExcluirSubEtapasEtapasTemplateDetalhe', value)
    },
    removerExclusaoEtapaSubEtapa (value) {
      this.$emit('removerExclusaoEtapaSubEtapa', value)
    },
    EditaTemplatePergunta (value) {
      this.$emit('EditaTemplatePergunta', value)
    },
    editarEmMemoriaNovaPerguntaParaEtapa (value) {
      this.$emit('editarEmMemoriaNovaPerguntaParaEtapaTemplate', value)
    },
    editarEmMemoriaNovaPerguntaParaSubEtapa (value) {
      this.$emit('editarEmMemoriaNovaPerguntaParaSubEtapaTemplate', value)
    },
    EditaTemplateNovaPergunta (value) {
      this.$emit('EditaTemplateNovaPergunta', value)
    },
    addNovaPerguntaImagem (value) {
      this.$emit('addNovaPerguntaImagem', value)
    },
    EditarNovaPerguntaImagem (value) {
      this.$emit('EditarNovaPerguntaImagem', value)
    },
    removerImagemNova (value) {
      this.$emit('removerImagemNova', value)
    },
    removerEtapaEstatica (value) {
      this.$emit('removerEtapaEstatica', value)
    },
    removerEtapaEquipamentoEstatica (value) {
      this.$emit('removerEtapaEquipamentoEstatica', value)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/components/TemplateDetail/templateDetail.js